import { useQuery } from '@tanstack/react-query';
import { OilSupplierService } from 'services/openapi';
import { OilSupplierQueryKeys } from './constants';

export const useGetOilSuppliersQuery = (variables?: {
  page?: string;
  pageSize?: string;
  searchString?: string;
  typeId?: string;
}) => {
  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery({
    queryKey: [OilSupplierQueryKeys.GET_OIL_SUPPLIERS, variables],
    queryFn: () =>
      OilSupplierService.oilSupplierControllerGetAll(
        variables?.searchString,
        variables?.typeId,
        variables?.page,
        variables?.pageSize,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    error,
    data: data?.data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};

export const useGetOilSupplierDetailQuery = (id: string) => {
  return useQuery({
    queryKey: [OilSupplierQueryKeys.GET_OIL_SUPPLIER_DETAIL, id],
    queryFn: () => OilSupplierService.oilSupplierControllerGetDetail(id),
    enabled: !!id,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};
